.shipment-limit-option-count {
  color: var(--gray-212c36);
}
